import type { TFunction } from "i18next"
import { CURRENCY, type ICurrency } from "@/store/apis/balanceAPI"
import { STORE_CURRENCY } from "@/store/apis/storePaymentsAPI"

// CURRENCY.GOLDEN_DUST ("goldenDust") and STORE_CURRENCY.GOLDEN_DUST ("golden-dust")
// are different string literals, so both coexist in the map without collision.
const CURRENCY_KEY_MAP: Record<ICurrency | STORE_CURRENCY, string> = {
  [CURRENCY.TON]: "ton",
  [CURRENCY.STAR]: "star",
  [CURRENCY.GOLDEN_DUST]: "goldenDust",
  [CURRENCY.LABR]: "labr",
  [STORE_CURRENCY.EXTERNAL_TON]: "ton",
  [STORE_CURRENCY.TG_STARS]: "star",
  [STORE_CURRENCY.GOLDEN_DUST]: "goldenDust"
}

export function getCurrencyLabel(
  t: TFunction,
  currency: ICurrency | STORE_CURRENCY,
  count?: number
): string {
  return t(`currency.${CURRENCY_KEY_MAP[currency]}`, { count })
}
